module.exports = __webpack_public_path__ + "img/tip7.f439f693.png";